export const references = {

  "morbus-fabry": [
    {
      "subtitle": "",
    },
    [
      {
        "sup": 1,
        "text": "MEIKLE, P. et al. JAMA. 1999: 249–254.",
      },
      {
        "sup": 2,
        "text": "SPADA, M. et al. Am J Hum Genet. 2006: 31–40.",
      },
      {
        "sup": 3,
        "text": "HOPKINS, P. et al. J Pediatr. 2015: 172–177.",
      },
      {
        "sup": 4,
        "text": "WITTMANN J et al. JIMD Rep. 2012: 117–125.",
      },
      {
        "sup": 5,
        "text": "HWU, WL. et al. Hum Mutat. 2009: 1397–1405.",
      },
      {
        "sup": 6,
        "text": "MACDERMOT, KD. et al. J Med Genet. 2001: 750–760.",
      },
      {
        "sup": 7,
        "text": "MACDERMOT, KD. et al. J Med Genet. 2001: 769–775.",
      },
      {
        "sup": 8,
        "text": "KÖPING, M. et al. Orphanet J Rare Dis. 2018: 137.",
      },
      {
        "sup": 9,
        "text": "CARMONA, S. et al. Audiol Res. 2017: 176.",
      },
      {
        "sup": 10,
        "text": "HEGEMANN, S. et al. Eur J Clin Invest. 2006: 654–662.",
      },
      {
        "sup": 11,
        "text": "HOFFMANN, B. et al. Clin Gastroenterol Hepathol. 2007: 1447–1453.",
      },
      {
        "sup": 12,
        "text": "WEIDEMANN, F. et al. Int J Cardiol. 2010: 3–10.",
      },
      {
        "sup": 13,
        "text": "WALDEK, S. et al. Genet Med. 2009: 790–796.",
      },
      {
        "sup": 14,
        "text": "MORRISSEY, RP. et al. Cardiovasc J Afr. 2011: 38–44.",
      },
      {
        "sup": 15,
        "text": "HOFFMANN, B. et al. Hepatology. 2007: 1447–1453.",
      },
      {
        "sup": 16,
        "text": "HOPKIN, RJ. et al. Pediatr Res. 2008: 550–555.",
      },
      {
        "sup": 17,
        "text": "RAMASWAMI, U. et al. Acta Paediatrica. 2006: 86–92.",
      },
      {
        "sup": 18,
        "text": "PENSABENE, L. et al. Gastroenterol Res Pract. 2016: 9712831.",
      },
      {
        "sup": 19,
        "text": "HOFFMANN, B. et al. Clin J Pain. 2007: 535–542.",
      },
      {
        "sup": 20,
        "text": "ÜÇEYLER, N. et al. Clin J Pain. 2014: 915–920.",
      },
      {
        "sup": 21,
        "text": "MEHTA, A. et al. Q J Med. 2010: 641–649.",
      },
      {
        "sup": 22,
        "text": "KOLODNY, E. & PASTORES, G. Am Soc Nephrol. 2002: S150–S513.",
      },
      {
        "sup": 23,
        "text": "LAO, LM. et al. J Dermatol Sci. 1998: 109–117.",
      },
      {
        "sup": 24,
        "text": "MØLLER, AT. et al. J Peripher Nerv Syst. 2009: 159–164.",
      },
      {
        "sup": 25,
        "text": "SIMS, K. et al. Stroke. 2009: 788–794.",
      },
      {
        "sup": 26,
        "text": "SODI, A. et al. Br J Ophthalmol. 2007: 210–214.",
      },
      {
        "sup": 27,
        "text": "PITZ, S. et al. PLoS One. 2015: e0120814.",
      },
      {
        "sup": 28,
        "text": "KALKUM, G. et al. BMC Ophtalmol. 2016: 202.",
      },
      {
        "sup": 29,
        "text": "WANNER, C. et al. Clin J Am Soc Nephrol. 2010: 2220–2228.",
      },
      {
        "sup": 30,
        "text": "PISANI, A. et al. Nephrol Dial Transplant. 2018: 318–323.",
      },
      {
        "sup": 31,
        "text": "RIES, M. et al. Kidney Int. 2004: 978–982.",
      },
      {
        "sup": 32,
        "text": "BECK, M. In: MEHTA, A. et al. (Hrsg.) Fabry Disease: Perspectives from\n 5 Years of FOS. Oxford   PharmaGenesis Ltd; 2006; Chapter 16.\n Verfügbar unter: https://www.ncbi.nlm.nih.gov/pubmed/21290683\n [letzter Zugriff: 02.03.2020].",
      },
      {
        "sup": 33,
        "text": "NAKAO, S. et al. Kidney Int. 2003: 801–807.",
      },
      {
        "sup": 34,
        "text": "KOTANKO, P. et al. J Am Soc Nephrol. 2004: 1323–1329.",
      },
      {
        "sup": 35,
        "text": "TANAKA, M. et al. Clin Nephrol. 2005: 281–287.",
      },
      {
        "sup": 36,
        "text": "GASPAR, P. et al. BMC Med Genet. 2010: 19.",
      },
      {
        "sup": 37,
        "text": "KLEINERT, J. et al. Transpl Int. 2009: 287–292.",
      },
      {
        "sup": 38,
        "text": "LIDOVE, O. et al. In: MEHTA, A. et al. (Hrsg.). Fabry Disease Perspectives\n from 5 Years of FOS. Oxford PharmaGenesis Ltd; 2006; Chapter 24.\n Verfügbar unter: https:// www.ncbi.nlm.nih.gov/pubmed/21290683/\n [letzter Zugriff: 02.03.2020].",
      },
      {
        "sup": 39,
        "text": "LARRALDE, M. et al. Arch Dermatol. 2004: 1440–1446.",
      },
      {
        "sup": 40,
        "text": "BARBEY, F. et al. Curr Med Chem Cardiovasc Haematol Agents. 2004;\n 277–286.",
      },
      {
        "sup": 41,
        "text": "Openstax College, Rice University. Biology (2013). ISBN–10\n 1938168399; ISBN–13; 978–1–938168–39–0; Revision C–1–000–DW. Verfügbar unter: https://openstax.org/",
      },
      {
        "sup": 42,
        "text": "SCHÄFER, E. et al. Hum Mutat. 2005: 412.",
      },
      {
        "sup": 43,
        "text": "BARBA–ROMERO, M–Á. et al. Int J Clin Pract. 201: 903–910.",
      },
      {
        "sup": 44,
        "text": "Human Gene Mutation Database. Verfügbar unter:\n http://www.hgmd.cf.ac.uk/ac/gene.php?gene=GLA [letzter Zugriff: 29.09.2020]",
      },
      {
        "sup": 45,
        "text": "SMID, BE. et al. J Med Genet. 2015: 262–268.",
      },
      {
        "sup": 46,
        "text": "DESNICK, RJ. et al. a–Galactosidase A deficiency: Fabry disease. In:\n SCRIVER, CR. et al. (Hrsg.) The metabolic and molecular bases\n of inherited disease, 8th ed. New York: McGraw-Hill, 2001: 3733–3774.",
      },
      {
        "sup": 47,
        "text": "WHYBRA, C. et al. Klinische Manifestation des Morbus Fabry bei\n Kindern. In: Neuropädiatrie. 2;2005: 44–48.",
      },
      {
        "sup": 48,
        "text": "ENG, CM. et al. J Inherit Metab Dis. 2007: 184–192.",
      },
      {
        "sup": 49,
        "text": "REISIN, R. et al. Int J Clin Pract. 2017: e12914.",
      },
      {
        "sup": 50,
        "text": "MEHTA, A. et al. Eur J Clin Invest. 2004: 236–242.",
      },
      {
        "sup": 51,
        "text": "DOBYNS, WB. et al. Am J Med Genet A. 2004: 136–143.",
      },
      {
        "sup": 52,
        "text": "WANG, RY. et al. Genet Med. 2007: 34–45.",
      },
      {
        "sup": 53,
        "text": "ORTIZ, A. et al. Mol Genet Metab. 2018: 416–427.",
      },
      {
        "sup": 54,
        "text": "LYON, MF. Nature. 1961: 372–373.",
      },
      {
        "sup": 55,
        "text": "LU, YH. et al. J Hum Genet. 2018: 1–8.",
      },
      {
        "sup": 56,
        "text": "RUDOLPH, C. et al. Kinderärztliche Praxis (Sonderheft Morbus Fabry).\n 2018: 3–5.",
      },
      {
        "sup": 57,
        "text": "SVARSTAD, E. et al. Clin Nephrol. 2005: 394–401.",
      },
      {
        "sup": 58,
        "text": "BÖTTCHER, T. et al. PLOS One. 2013: e71894.",
      },
      {
        "sup": 59,
        "text": "TANISLAV, C. et al. Eur J Neurol. 2011: 631–636.",
      },
      {
        "sup": 60,
        "text": "LIDOVE, O. et al. Joint Bone Spine. 2016: 421–426.",
      },
    ],
  ],

  "diagnose": [
    {
      "subtitle": "",
    },
    [
      {
        "sup": 1,
        "text": "BECK, M. In: MEHTA, A. et al. (Hrsg.) Fabry Disease Perspectives from 5 Years of FOS. Oxford PharmaGenesis Ltd; 2006; Chapter\n16. Verfügbar unter: https://pubmed.ncbi.nlm.nih.gov/21290683/ [letzter Zugriff: 23.06.2020].",
      },
      {
        "sup": 2,
        "text": "MEHTA, A. et al. Eur J Clin Invest. 2004: 236–242.",
      },
      {
        "sup": 3,
        "text": "MACDERMOT, KD. et al. J Med Genet. 2001: 750–760.",
      },
      {
        "sup": 4,
        "text": "MACDERMOT, KD. et al. J Med Genet. 2001: 769–775.",
      },
      {
        "sup": 5,
        "text": "BAEHNER, F. et al. J Inherit Metab Dis. 2003: 617–627.",
      },
      {
        "sup": 6,
        "text": "LANEY, DA. & FERNHOFF, PM. J Genet Couns. 2008: 79–83.",
      },
      {
        "sup": 7,
        "text": "LANEY, DA. et al. J Genet Couns. 2013: 555–564.",
      },
      {
        "sup": 8,
        "text": "GAL, A. et al. Eur J Hum Genet. 2012; 20.",
      },
      {
        "sup": 9,
        "text": "SMID, BE. et al. J Med Genet. 2015: 262–268.",
      },
      {
        "sup": 10,
        "text": "TALBOT, A. et al. Mol Genet Metab. 2017: 121–125.",
      },
      {
        "sup": 11,
        "text": "AERTS, JM. et al. Proc Natl Acad Sci USA. 2008: 2812–2817.",
      },
      {
        "sup": 12,
        "text": "NOWAK, A. et al. Mol Genet Metab. 2017: 57–61.",
      },
      {
        "sup": 13,
        "text": "DUPONT, FO. et al. Curr Med Chem. 2013: 280–288.",
      },
      {
        "sup": 14,
        "text": "NIEMANN, M. et al. Circ Cardiovasc Genet. 2014: 8–16.",
      },
      {
        "sup": 15,
        "text": "LUKAS, J. et al. Hum Mutat. 2016: 43–51.",
      },
      {
        "sup": 16,
        "text": "FERRAZ, MJ. et al. Biochim Biophys Acta. 2014: 811–825.",
      },
      {
        "sup": 17,
        "text": "ARENDS, M. et al. Mol Genet Metab. 2017: 157–161.",
      },
      {
        "sup": 18,
        "text": "SAKURABA, H. et al. Clin Exp Nephrol. 2018: 843–849.",
      },
      {
        "sup": 19,
        "text": "ROMBACH, SM. et al. PLoS One. 2012: e47805.",
      },
      {
        "sup": 20,
        "text": "LENDERS, M. et al. J Am Soc Nephrol. 2016: 256–264.",
      },
      {
        "sup": 21,
        "text": "LENDERS, M. et al. J Allergy Clin Immunol. 2018: 2289–2292.",
      },
      {
        "sup": 22,
        "text": "TSUBOI, K. et al. BMC Pharmacol Toxicol. 2017: 43.",
      },
      {
        "sup": 23,
        "text": "FERRAZ, MJ. et al. FEBS Lett. 2016: 716–725.",
      },
      {
        "sup": 24,
        "text": "POLO, G. et al. Clin Chem Lab Med. 2017: 403–414.",
      },
      {
        "sup": 25,
        "text": "VAN BREEMEN, MJ. et al. Biochim Biophys Acta. 2011: 70–76.",
      },
      {
        "sup": 26,
        "text": "GERMAIN, DP. et al. N Engl J Med. 2016: 545–555.",
      },
      {
        "sup": 27,
        "text": "LIU, HC. et al. Orphanet J Rare Dis. 2014: 111.",
      },
      {
        "sup": 28,
        "text": "BENJAMIN, ER. et al. Genet Med. 2017: 430–438 (und ergänzende Materialien).",
      },
    ],
  ],

  "therapie": [
    {
      "subtitle": "",
    },
    [
      {
        "sup": 1,
        "text": "AWMF-Leitlinien-Register Nr. 030/134: Interdisziplinäre Leitlinie für die Diagnose und Therapie des Morbus Fabry; Verfügbar unter: https://dgn.org/wp-content/uploads/2015/10/030-134l_S2k_Morbus_Fabry_Diagnose_Therapie_2013-verlaengert_archiviert.pdf [letzter Zugriff: 16.10.2020].",
      },
      {
        "sup": 2,
        "text": "HUGHES, D. et al. In: MEHTA, A. et al. (Hrsg.) Fabry Disease: Perspectives from 5 Years of FOS. Oxford PharmaGenesis Ltd; 2006; Chapter 35. Verfügbar unter: https://www.ncbi.nlm.nih.gov/pubmed/21290683 [Letzter Zugriff: 23.06.2020].",
      },
      {
        "sup": 3,
        "text": "LANEY, DA. et al. J Genet Couns. 203: 555–564.",
      },
      {
        "sup": 4,
        "text": "GAL, A. et al. Eur J Hum Genet. 2012: 20.",
      },
      {
        "sup": 5,
        "text": "VAN DER TOL, L. et al. J Med Genet. 2014: 1–9.",
      },
      {
        "sup": 6,
        "text": "BROUNS, R. et al. Stroke. 2010: 863–868",
      },
      {
        "sup": 7,
        "text": "ROLFS, A. et al. Stroke. 2013: 340–349.",
      },
      {
        "sup": 8,
        "text": "DU MOULIN, M. et al. Clin Genet. 2017: 528–533.",
      },
    ],
  ],

  "fachgebiete": [
    {
      "subtitle": "Kardiologie",
    },
    [
      {
        "sup": 1,
        "text": "WALDEK, S. et al. Genet Med. 2009; 11(11). 790–796.",
      },
      {
        "sup": 2,
        "text": "MORRISSEY, R.P. et al. Cardiovasc J Afr. 2011; 22(1). 38–44.",
      },
      {
        "sup": 3,
        "text": "LINHART, A. et al. Eur Heart J. 2007; 28. 1228–1235.",
      },
      {
        "sup": 4,
        "text": "KAMPMANN, C. et al. J Am Soc Nephrol. 2002; 13(Suppl. 2). 147–149.",
      },
      {
        "sup": 5,
        "text": "NAKAO, S. et al. N Engl J Med. 1995; 333(5). 288–93.",
      },
      {
        "sup": 6,
        "text": "PALECEK, T. et al. J Inherit Metab Dis. 2014; 37(3). 455–460.",
      },
      {
        "sup": 7,
        "text": "MONSERRAT, L. et al. J Am Coll Cardiol. 2007; 50(25). 2399–2403.",
      },
      {
        "sup": 8,
        "text": "NIEMANN, M. et al. Heart. 2010; 96(23). 1915–1919.",
      },
      {
        "sup": 9,
        "text": "YILMAZ, A. et al. (2019). Kardiologe. 13. 264-291.",
      },
      {
        "sup": 10,
        "text": "TERRYN, W. et al. Int J Cardiol. 2013 ; 167(6). 2555–2560.",
      },
      {
        "sup": 11,
        "text": "BIEGSTRAATEN, M. et al. Orphanet J Rare Dis. 2015; 10. 36.",
      },
      {
        "sup": 12,
        "text": "NAMDAR, M, et al. Heart. 2011; 97(6). 485–990.",
      },
      {
        "sup": 13,
        "text": "NIEMANN, M. et al. J Inherit Metab Dis. 2013; 36(5). 873–879.",
      },
      {
        "sup": 14,
        "text": "NAMDAR, M. et al. Am J Cardiol. 2012; 109(4). 587–593.",
      },
      {
        "sup": 15,
        "text": "FRUSTACI, A. & CHIMENTI, C. Circulation. 2007; 116(12). e350–351.",
      },
      {
        "sup": 16,
        "text": "WEIDEMANN, F. et al. Int J Cardiol. 2010; 141(1). 3–10.",
      },
      {
        "sup": 17,
        "text": "KAMPMANN, C. et al. J Am Soc Nephrol. 2002; 13(Suppl.2). 147–149.",
      },
      {
        "sup": 18,
        "text": "AWMF-Leitlinien-Register Nr. 030/134: Interdisziplinäre Leitlinie für die Diagnose und Therapie desMorbus Fabry. 2013. Verfügbar unter: www.awmf.org/uploads/tx_szleitlinien/030-134m_S2k_Morbus_Fabry_Diagnose_Therapie_2013-abgelaufen.pdf [Letzter Zugriff: 14.04.2020].",
      },
      {
        "sup": 19,
        "text": "SERRA, W. & MARZILIANO, N. Cardiovasc Ultrasound. 2019; 17(1). 1.",
      },
      {
        "sup": 20,
        "text": "LIU, D. et al. Eur J Med Res. 2016;21(1). 21.",
      },
      {
        "sup": 21,
        "text": "WEIDEMANN, F. et al. Mol Genet Metab. 2019; 126(2). 169–182.",
      },
      {
        "sup": 22,
        "text": "NORDIN, S. et al. JACC Cardiovasc Imaging. 2018;pii: S1936-878X(18)30307–3.",
      },
      {
        "sup": 23,
        "text": "DERBODE, E. et al. Diagn Interv Imaging. 2020; 101(2). 59-67.",
      },
      {
        "sup": 24,
        "text": "FEUSTEL, A. et al. PLoS One. 2014; 9(3): e91757.0",
      },
      {
        "sup": 25,
        "text": "TANISLAV, C. et al. PLoS One. 2016; 11(6): e0157640.",
      },
      {
        "sup": 26,
        "text": "GERMAIN, D.P. Orphanet J Rare Dis. 2010; 5. 30.",
      },
      {
        "sup": 27,
        "text": "The Criteria Committee of the New York Heart Association. Nomenclature and Criteria for Diagnosis of",
      },
      {
        "sup": 28,
        "text": "Diseases of the Heart and Great Ves¬sels. 9th ed. Boston, Mass: Little, Brown & Co; 1994: 253–256. CAMPEAU, L. Circulation. 1976 ;54(3). 522–523.",
      },
      {
        "sup": 29,
        "text": "MACDERMIT, K.D. et al. J Med Genet. 2001; 38(11). 750–760.",
      },
      {
        "sup": 30,
        "text": "MACDERMIT, K.D. et al. J Med Genet. 2001; 38(11). 769–775.",
      },
      {
        "sup": 31,
        "text": "WANNER, C. et al. Mol Genet Metab. 2018; 124 (3). 189–203.",
      },
      {
        "sup": 32,
        "text": "PARINI, R. et al. Drug Des Devel Ther. 2020; 14. 2149–2158.",
      },
    ],
    {
      "subtitle": "Nephrologie",
    },
    [
      {
        "sup": 1,
        "text": "OTTLEWSKI, I. et al. Kidney Int. 2019; 96(1). 222–2230.",
      },
      {
        "sup": 2,
        "text": "BRANTON, M.H. et al. Medicine. 2002; 81. 122–138.",
      },
      {
        "sup": 3,
        "text": "BECK, M. In: MEHTA, A. et al. (Hrsg.) Fabry Disease: Perspectives from 5 Years of FOS. Oxford PharmaGenesis Ltd; 2006; Chapter 16. Verfügbar unter: https://www.ncbi.nlm.nih.gov/books/NBK11581/ [Letzter Zugriff: 11.03.2021].",
      },
      {
        "sup": 4,
        "text": "WALDEK, S. & FERIOZZI, S. BMC Nephrology. 2014; 15. 72",
      },
      {
        "sup": 5,
        "text": "CYBULLA, M. et al. Dtsch Med Wochenschr. 2007; 132. 1505–1509.",
      },
      {
        "sup": 6,
        "text": "MEHTA, A. et al. Eur J Clin Invest. 2004; 34(3). 236–242.",
      },
      {
        "sup": 7,
        "text": "NAKAO, S. et al. Kidney Int. 2003; 64(3). 801–807.",
      },
      {
        "sup": 8,
        "text": "KOTANKO, P. et al. J Am Soc Nephrol. 2004; 15. 1323–1329.",
      },
      {
        "sup": 9,
        "text": "TANAKA, M. et al. Clin Nephrol. 2005; 64(4). 281–287.",
      },
      {
        "sup": 10,
        "text": "GASPAR, P. et al. BMC Med Genet. 2010; 11.",
      },
      {
        "sup": 11,
        "text": "KLEINERT, J. et al. Transpl Int. 2009; 22. 287–292.",
      },
      {
        "sup": 12,
        "text": "YALIN, S.F. et al. Nephron. 2019; 142(1). 26–33.",
      },
      {
        "sup": 13,
        "text": "TURKMEN, K. et al. Kidney Blood Press Res 2016; 41. 1016–1024.",
      },
      {
        "sup": 14,
        "text": "MOISEEV, S. et al. Nephron. 2019; 141(4). 249–255.",
      },
      {
        "sup": 15,
        "text": "WEST, M. et al. J Am Soc Nephrol. 2009; 20(5). 1132–1139.",
      },
      {
        "sup": 16,
        "text": "SCHIFFMANN, R. et al. Nephrol Dia l Transplant. 2009; 24(7). 2102-2111.",
      },
      {
        "sup": 17,
        "text": "WANNER, C. et al. Clin J Am Soc Nephrol. 2010; 5. 2220–2228.",
      },
      {
        "sup": 18,
        "text": "RAMASWAMI, U. et al. Clin J Am Soc Nephrol. 2010; 5(2). 365–370.",
      },
      {
        "sup": 19,
        "text": "PISANI, A. et al. Nephrol Dial Transplant. 2018; 33(2). 318–323.",
      },
      {
        "sup": 20,
        "text": "33(2). 318–323. RIES, M. et al. Kidney Int. 2004; 66(3). 78–82.",
      },
      {
        "sup": 21,
        "text": "BRADY, R.O. & SCHIFFMANN, R. JAMA. 2000; 284(21). 2771–2775.",
      },
    ],
    {
      "subtitle": "Neurologie",
    },
    [
      {
        "sup": 1,
        "text": "GERMAIN, D.P. Orphanet J Rare Dis. 2010; 5. 30.",
      },
      {
        "sup": 2,
        "text": "SCHELLECKES, M et al. Orphanet J Rare Dis. 2014; 9. 178.",
      },
      {
        "sup": 3,
        "text": "MEHTA, A. et al. Eur J Clin Invest. 2004; 34. 236–242.",
      },
      {
        "sup": 4,
        "text": "SIMS, K. et al. Stroke. 2009; 40. 788–794.",
      },
      {
        "sup": 5,
        "text": "MITSIAS, P. & LEVINE, S.R. Ann Neurol. 1996; 40. 8–17.",
      },
      {
        "sup": 6,
        "text": "BROUNS, R. et al. Stroke. 2010; 41. 863–868.",
      },
      {
        "sup": 7,
        "text": "ENG, C.M. et al. Genet Med. 2006; 8. 539–548.",
      },
      {
        "sup": 8,
        "text": "BURLINA, A.P. et al. BMC Neurol. 2011; 11. 61.",
      },
      {
        "sup": 9,
        "text": "SCHIFFMANN, R. & MOORE D.F. In: MEHTA, A. et al. (Hrsg.) Fabry Disease: Perspectives from 5 Years of FOS. Oxford PharmaGenesis Ltd; 2006; Chapter 22. Verfügbar unter: https://www.ncbi.nlm.nih.gov/books/NBK11602/ (Letzter Zugriff: 11.03.2021]",
      },
      {
        "sup": 10,
        "text": "BUECHNER, S. et al. J Neurol Neurosurg Psychiatry 2008; 79. 1249–1254.",
      },
      {
        "sup": 11,
        "text": "BÖTTCHER, T et al. PLOS ONE. 2013; 8. e71894.",
      },
      {
        "sup": 12,
        "text": "GINSBERG, L. In: MEHTA, A. et al. (Hrsg.) Fabry Disease: Perspectives from 5 Years of FOS. Oxford PharmaGenesis Ltd; 2006; Chapter 23. Verfügbar unter: https://www.ncbi.nlm.nih.gov/books/NBK11613/ [Letzter Zugriff: 11.03.2021].",
      },
      {
        "sup": 13,
        "text": "HOFFMANN, B. et al. Clin J Pain. 2007; 23. 535–542.",
      },
      {
        "sup": 14,
        "text": "RAMASWAMI, U. et al. Acta Paediatr. 2006; 95. 86–92.",
      },
      {
        "sup": 15,
        "text": "Adult Fabry disease standard; operating procedures, UK. 2013. Verfügbar unter edrep.org/media/download_gallery/ SOP_for_Anderson_Fabry_ disease.pdf. [Letzer Zugriff: 2.11. 2018].",
      },
      {
        "sup": 16,
        "text": "TANISLAV, C. et al. Eur J Neurol. 2011; 18. 631–636.",
      },
      {
        "sup": 17,
        "text": "SCHIFFMANN, R. Acta Neurol Belg. 2006; 106. 61–65.",
      },
      {
        "sup": 18,
        "text": "HSU, J.L. et al. PLOS ONE 2017; 12:. 0183948",
      },
      {
        "sup": 19,
        "text": "POLITEI, J. et al. CNS Neurosci Ther. 2016; 22. 568–576.",
      },
      {
        "sup": 20,
        "text": "ÜÇEYLER, N. et al. Clin J Pain. 2014; 30.915–920.",
      },
      {
        "sup": 21,
        "text": "HEUSS, D. et al. Diagnostik bei Polyneuropathien, S1-Leitlinie, 2019, in: Deutsche Gesellschaft für Neurologie (Hrsg.), Leitlinien für Diagnostik und Therapie in der Neurologie; verfügbar unter:www.dgn.org/leitlinien [Letzter Zugriff: 12.02.2021]",
      },
      {
        "sup": 22,
        "text": "MEHTA, A. in MEHTA, A. et al. (Hrsg.) Fabry Disease: Perspectives from 5 Years of FOS. Oxford PharmaGenesis Ltd; 2006; Chapter 19. Verfügbar unter: https://www.ncbi.nlm.nih.gov/books/NBK11572/ [Letzter Zugriff: 11.03.2021].",
      },
      {
        "sup": 23,
        "text": "FELLGIEBEL, A. et al. Cerebrovasc Dis. 2014; 38(6). 448–456.",
      },
      {
        "sup": 24,
        "text": "FELLGIEBEL, A. et al. J Inherit Metab Dis. 2012; 35(2). 363–367.",
      },
      {
        "sup": 25,
        "text": "LELIEVELD, I.M. et al. PLOS ONE 2015; 10(9). e0137603.",
      },
      {
        "sup": 26,
        "text": "The LADIS Study Group. Cerebrovasc Dis. 2011; 32. 577−588.",
      },
      {
        "sup": 27,
        "text": "BASILE, A.M. et al. Cerebrovasc Dis. 2006; 21. 315−322.",
      },
      {
        "sup": 28,
        "text": "ANDERSSON, M. et al. J Neurol Neurosurg Psychiatry. 1994; 57(8). 897–902.",
      },
      {
        "sup": 29,
        "text": "REIBER, H. et al. Mult Scler. 1998; 4(3). 111–117.",
      },
      {
        "sup": 30,
        "text": "HOFFMANN, B. & MAYATEPEK, E. Dtsch Arztebl INT. 2009; 106826). 440–447.",
      },
    ],
  ]
}
